/* CelestialKinThreads - the $10 Couples Score Report add-on.

   Kept in its own asset rather than folded into ckt-birth-fields.js. That file
   is 22KB and every theme write is a whole-file replace, so touching it to add
   a feature means re-uploading all 22KB of tested code and re-proving it byte
   for byte. This file is additive: ckt-birth-fields.js is unchanged and still
   carries checksum a30f582454d68c46c797b3cf92ffbff6.

   The report is a real product (SKU CKT-SCOREREPORT, variant 54601117663507),
   not a line-item property, because Shopify cannot attach a price to a
   property. The SKU is deliberately two segments so _parse_ckt_sku in app.py
   returns None for it and the webhook's line-item loop falls through to the
   portrait SKU without ever mistaking the add-on for a portrait.

   Ticking the box writes to the cart immediately rather than at submit: the
   customer sees the charge and the cart count change straight away, and
   nothing has to race the theme's own add-to-cart handler.

   Everything here is defensive. A store with no cart endpoint, a fetch that
   fails, a browser with no fetch at all - in every one of those the checkbox
   reverts and says so out loud, rather than leaving the customer believing
   they bought something they did not. */
(function () {
  if (window.__cktScoreAddon) return;
  window.__cktScoreAddon = true;

  var ADDON_VARIANT_ID = 54601117663507;
  var ADDON_SKU = 'CKT-SCOREREPORT';
  var ADDON_HANDLE = 'couples-score-report';
  /* Every couples portrait SKU starts with this. The report is an ADD-ON: it
     is meaningless without a couples chart to report on, and it must never be
     sellable on its own. */
  var COUPLES_SKU_PREFIX = 'CKT-COU';
  /* The real handle. It is 'couples-compatibility-soul-portrait', not the
     shorter form the product title suggests — guessing it produced a link
     to a 404. */
  var COUPLES_URL = '/products/couples-compatibility-soul-portrait';

  /* .ckt-check and .ckt-hint are defined by ckt-birth-fields.js, which is
     always on the page before this one. Only the card's own rules live here. */
  var CSS =
    '.ckt-addon{margin-top:1rem;padding:.9rem 1rem;border:1px solid rgba(0,0,0,.18);border-radius:.4rem;background:rgba(0,0,0,.03)}' +
    '.ckt-addon .ckt-check{margin-top:0}' +
    '.ckt-addon .ckt-hint{margin-top:.45rem}' +
    '.ckt-addon-status{font-size:.82rem;margin-top:.4rem;opacity:.8;min-height:1.1em}' +
    '.ckt-addon-status.bad{color:#b03030;opacity:1}' +
    '.ckt-addon-only{margin:1.25rem 0;padding:1.1rem 1.2rem;border:1px solid rgba(0,0,0,.18);' +
      'border-radius:.5rem;background:rgba(0,0,0,.03);font-size:1rem;line-height:1.5}' +
    '.ckt-addon-only strong{display:block;margin-bottom:.35rem}';

  function el(tag, attrs) {
    var n = document.createElement(tag);
    for (var k in attrs) {
      if (k === 'text') n.textContent = attrs[k];
      else if (k === 'html') n.innerHTML = attrs[k];
      else n.setAttribute(k, attrs[k]);
    }
    return n;
  }

  /* Same test ckt-birth-fields.js uses to decide it is building a couples
     form, so the card can never appear on a page that has no second person. */
  function isCouples() {
    var hay = (location.pathname + ' ' + (document.title || '') + ' ' +
               ((document.querySelector('h1') || {}).textContent || '')).toLowerCase();
    return hay.indexOf('couple') > -1 || hay.indexOf('synastry') > -1 ||
           hay.indexOf('compatib') > -1;
  }

  function card() {
    var wrap = el('div', {'class': 'ckt-addon'});
    wrap.appendChild(el('style', {text: CSS}));

    var chk = el('input', {type: 'checkbox', id: 'ckt-addon-box'});
    var row = el('div', {'class': 'ckt-check'});
    row.appendChild(chk);
    row.appendChild(el('label', {'for': 'ckt-addon-box',
      html: '<strong>Add the Couples Score Report &mdash; $10</strong>'}));
    wrap.appendChild(row);
    wrap.appendChild(el('div', {'class': 'ckt-hint',
      text: 'Your portrait names a tier and a phrase for each category — never a '
          + 'number. This is the only place the numbers are written down: every '
          + 'category score, plus the Attraction Score that does not appear on the '
          + 'portrait at all, each with a few paragraphs on what it means for your '
          + 'two charts specifically. Emailed as soon as your chart is calculated '
          + '— it does not wait on printing or shipping.'}));
    var status = el('div', {'class': 'ckt-addon-status'});
    wrap.appendChild(status);

    function say(msg, bad) {
      status.textContent = msg || '';
      status.className = 'ckt-addon-status' + (bad ? ' bad' : '');
    }

    function cartFetch(url, body) {
      if (typeof fetch !== 'function') return Promise.reject(new Error('no fetch'));
      return fetch(url, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) throw new Error('cart returned ' + r.status);
        return r.json();
      });
    }

    /* Find the add-on's line key in the cart, or null. */
    function findLine() {
      if (typeof fetch !== 'function') return Promise.resolve(null);
      return fetch('/cart.js', {headers: {'Accept': 'application/json'}})
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart || !cart.items) return null;
          for (var i = 0; i < cart.items.length; i++) {
            if (String(cart.items[i].id) === String(ADDON_VARIANT_ID) ||
                cart.items[i].sku === ADDON_SKU) return cart.items[i].key;
          }
          return null;
        })
        .catch(function () { return null; });
    }

    chk.addEventListener('change', function () {
      chk.disabled = true;
      if (chk.checked) {
        say('Adding…');
        cartFetch('/cart/add.js', {items: [{id: ADDON_VARIANT_ID, quantity: 1}]})
          .then(function () { say('Added to your cart. You will see it at checkout.'); })
          .catch(function () {
            chk.checked = false;
            say('Could not add it just now — please try again, or add the Couples Score Report from the shop.', true);
          })
          .then(function () { chk.disabled = false; });
      } else {
        say('Removing…');
        findLine().then(function (key) {
          if (!key) { say(''); chk.disabled = false; return; }
          return cartFetch('/cart/change.js', {id: key, quantity: 0})
            .then(function () { say(''); })
            .catch(function () {
              chk.checked = true;
              say('Could not remove it — you can take it out in the cart.', true);
            })
            .then(function () { chk.disabled = false; });
        });
      }
    });

    /* If it is already in the cart (they ticked it, wandered off, came back),
       show the box ticked rather than letting them add a second one. */
    findLine().then(function (key) {
      if (key) { chk.checked = true; say('Already in your cart.'); }
    });

    return wrap;
  }

  /* ── the add-on may not be bought on its own ──────────────────────────────
     Shopify Basic has no cart or checkout validation, so this cannot be
     enforced at the platform level. It is enforced in three places instead:
     here on the product page, here again on the cart, and finally on the
     server, which refuses to process a score report with no couples portrait
     beside it. A determined person with a hand-built cart permalink can still
     get one into checkout; the server catches that and tells the operator
     rather than silently taking the money and delivering nothing. */

  function onAddonProductPage() {
    return location.pathname.indexOf('/products/' + ADDON_HANDLE) > -1;
  }

  /* The report's own product page: no add-to-cart. It exists so the cart can
     hold a priced line item, not so anyone can buy it cold. */
  function guardProductPage() {
    if (!onAddonProductPage()) return true;

    /* ckt-birth-fields.js decides it is on a couples page by looking for the
       word "couple" anywhere in the title — and "Couples Score Report" contains
       it. So it plants a full two-person birth form on the add-on's own page,
       where there is nothing to collect. Remove it whenever it appears. */
    var stray = document.querySelectorAll('[data-ckt-fields]');
    for (var s = 0; s < stray.length; s++) {
      if (stray[s].parentNode) stray[s].parentNode.removeChild(stray[s]);
    }

    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].getAttribute('data-ckt-blocked')) continue;
      forms[i].setAttribute('data-ckt-blocked', '1');
      forms[i].style.display = 'none';
      var note = el('div', {'class': 'ckt-addon-only'});
      note.appendChild(el('style', {text: CSS}));
      note.appendChild(el('div', {html:
        '<strong>This is an add-on, not a standalone product.</strong>' +
        'The Couples Score Report explains the numbers behind a Couples ' +
        'Compatibility Portrait, so there is nothing for it to report on by ' +
        'itself. Add it with the checkbox on the ' +
        '<a href="' + COUPLES_URL + '">Couples Compatibility Portrait</a> page.'}));
      forms[i].parentNode.insertBefore(note, forms[i]);
    }

    /* Never "done". The birth-fields script keeps retrying for ten seconds, so
       a box removed now can be planted again a moment later. Returning false
       keeps this polling for its full fifteen and cleaning up after it. */
    return false;
  }

  /* The cart: if the report is in there with no couples portrait beside it,
     take it out and say so. Covers the back-button, a stale cart, and a
     portrait removed after the report was ticked. */
  function guardCart() {
    if (typeof fetch !== 'function') return;
    fetch('/cart.js', {headers: {'Accept': 'application/json'}})
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return;
        var addon = null, hasCouples = false;
        for (var i = 0; i < cart.items.length; i++) {
          var sku = String(cart.items[i].sku || '').toUpperCase();
          if (sku === ADDON_SKU || String(cart.items[i].id) === String(ADDON_VARIANT_ID)) {
            addon = cart.items[i];
          } else if (sku.indexOf(COUPLES_SKU_PREFIX) === 0) {
            hasCouples = true;
          }
        }
        if (!addon || hasCouples) return;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({id: addon.key, quantity: 0})
        }).then(function (r) {
          if (!r.ok) return;
          // Reloading is the only way to make every theme's cart markup agree
          // with the cart it just changed. The flag stops a reload loop if the
          // removal somehow does not stick.
          if (!sessionStorage.getItem('cktAddonPruned')) {
            try { sessionStorage.setItem('cktAddonPruned', '1'); } catch (e) {}
            location.reload();
          }
        });
      })
      .catch(function () { /* a cart we cannot read is a cart we do not touch */ });
  }

  /* ckt-birth-fields.js plants its box into whichever add-to-cart form it
     finds, and on a slow theme that can take a moment. Returns true when there
     is nothing left to do - either the card is in place, or this is not a
     couples page and never will be. */
  function attach() {
    if (onAddonProductPage()) return guardProductPage();
    if (!isCouples()) return true;
    var box = document.querySelector('[data-ckt-fields]');
    if (!box) return false;
    if (box.querySelector('.ckt-addon')) return true;
    box.appendChild(card());
    return true;
  }

  function start() {
    if (location.pathname.indexOf('/cart') === 0) guardCart();
    else if (isCouples()) { try { sessionStorage.removeItem('cktAddonPruned'); } catch (e) {} }
    if (attach()) return;
    var tries = 0;
    var iv = setInterval(function () {
      if (attach() || ++tries > 60) clearInterval(iv);
    }, 250);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();